import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { IHaloDropDown } from "./halo-dropdown.interface";

@Component({
  selector: "app-halo-dropdown",
  templateUrl: "./halo-dropdown.component.html",
  styleUrls: ["./halo-dropdown.component.scss"]
})
export class HaloDropdownComponent implements OnInit, OnChanges {
  @Input() default: string;
  @Input() selectedForm: string | number | null;
  @Input() options: IHaloDropDown[];
  @Output() dropdownChange = new EventEmitter<IHaloDropDown | null>();

  @HostListener("document:click", ["$event"])
  clickout(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      // close after select
      this.isOpen = false;
    }
  }

  isOpen: boolean = false;
  selected: string = "";
  selectedIndex: number | null;

  constructor(private eRef: ElementRef) { }

  ngOnInit() {
    this.selected = this.selected?this.selected:this.default;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.selectedForm && changes.selectedForm.currentValue !== changes.selectedForm.previousValue){
      if(this.options && changes.selectedForm.currentValue){
        let idx = this.options.findIndex((val:any) => val.value.toString() === changes.selectedForm.currentValue.toString());
        this.selectedIndex = idx;
        this.selected = this.options[idx].text;
      }
    }

    if(changes.default && changes.default.currentValue !== changes.default.previousValue){
      if(this.options  && changes.default.currentValue){
        const idx = this.options.findIndex((val:any) => val.value.toString() === changes.default.currentValue.toString());
        if(idx >= 0) {
          this.selectedIndex = idx;
          this.selected = this.options[idx].text;
          this.dropdownChange.emit(this.options[idx]);
        }
      }
    }

    if(changes.options && changes.options.currentValue !== changes.options.previousValue){
      this.options = changes.options.currentValue;
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  select(index: number) {
    if (typeof this.options[index] === "undefined") {
      this.update(null, null);
    } else {
      this.update(index, this.options[index]);
    }

    // close after select
    this.isOpen = false;
  }

  update(index: number | null, selected: IHaloDropDown | null) {
    this.selectedIndex = index;
    this.selected = selected ? selected.text : this.default;
    this.dropdownChange.emit(selected);
  }
}
